{
  "defaultLabel": "Copy",
  "success": "Copied!",
  "error": "Could not copy to clipboard"
}